import(/* webpackMode: "eager" */ "/var/app/current/src/app/error.tsx");
